module.exports = __webpack_public_path__ + "img/1.5.COD.744049f4.png";